import { IconHelper } from '@doppio/icons';
import { Pressable, Text, useSx, View } from 'dripsy';
import * as React from 'react';
import { Platform } from 'react-native';
import { Spacer } from '../Spacer';
import { Tooltip } from '../Tooltip';
export const FormControlLabel = ({ labelFor, isRequired, labelTooltip, children, }) => {
    const sx = useSx();
    const shouldRenderTooltip = Platform.OS === 'web' && Boolean(labelTooltip);
    let content = (React.createElement(Text, { sx: {
            fontWeight: 'medium',
            fontSize: '$1',
            lineHeight: '$3',
        } },
        children,
        isRequired && React.createElement(Text, { sx: { color: 'errorText' } }, "*")));
    if (shouldRenderTooltip) {
        content = (React.createElement(View, { sx: { flexDirection: 'row' } },
            content,
            React.createElement(Spacer, { width: "$1" }),
            React.createElement(Tooltip, { labelText: labelTooltip },
                React.createElement(Pressable, { sx: { width: '$5', height: '$5' }, accessibilityRole: "image", onPress: (event) => event.preventDefault() },
                    React.createElement(IconHelper, { color: "secondaryText" })))));
    }
    return Platform.select({
        web: (React.createElement("label", { style: sx({ marginBottom: '$1', wordBreak: 'break-word' }), htmlFor: labelFor }, content)),
        default: React.createElement(View, { sx: { marginBottom: '$1' } }, content),
    });
};
FormControlLabel.displayName = 'FormControlLabel';
//# sourceMappingURL=FormControlLabel.js.map